// 🔹 admissionUtils.js

import {
  normalizeCourse,
  extractStudentParts,
  getCourseYears,
} from "./commonHelpers";

// 1. Admission No
export const generateAdmissionNo = ({ prefix, course, studentId }) => {
  const cleanCourse = normalizeCourse(course);
  const { studentNo, year } = extractStudentParts(studentId);

  return `${prefix}/${cleanCourse}/Admn/${studentNo}/${year}`;
};

// 2. Course Duration
export const getCourseDuration = (course, academicYear) => {
  const years = getCourseYears(course);
  if (!years) return "";

  const [start] = academicYear.split("-");
  const end = Number(start) + years;

  return `${years} years (${start}-${end})`;
};

// 3. Salutation
export const getSalutation = (gender = "") => {
  const g = gender.trim().toLowerCase();

  if (g === "male") return { salute: "Mr.", title: "S/O",  possessive: "His" ,   pronoun: "he",
      hostel: "Boys Hostel",};
  if (g === "female") return { salute: "Ms.", title: "D/O", possessive: "Her", pronoun: "she", hostel: "Girls Hostel" };

  return { salute: "", title: "", possessive: "", pronoun: "", hostel: "" };
};